import gsap from "gsap/all";

export default () => ({
  init() {
    this.initAnimation();
  },

  initAnimation() {
    const inBackend = document.body.classList.contains("neos-backend");

    if (inBackend) return;

    const sections = document.querySelectorAll(
      ".content-section:not(.disable-default-animation)"
    );

    // add slide in class to section specific content
    sections.forEach((section) => {
      section
        .querySelectorAll(
          ".heading-h2, .heading-h3, .heading-h4, img, .rich-text, .slide-in"
        )
        .forEach((el) => {
          if (el.classList.contains("ignore-animation")) return;

          el.classList.add("slide-in-left-title");
        });
    });

    // remove .slide-in-left-title class within a teaser
    // because teaser component has its own animation
    document
      .querySelectorAll(
        ".content-section__content .teasers .slide-in-left-title, " +
          ".jonnitto-prettyembed-wrapper .slide-in-left-title, " +
          ".form-group .slide-in-left-title"
      )
      .forEach((slideInEl) => {
        slideInEl.classList.remove("slide-in-left-title");
      });

    // actual animation
    sections.forEach((section) => {
      const title = section.querySelectorAll(".slide-in-left-title");
      const circle = section.querySelectorAll(".slide-in-left-circle");

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 85%",
        },
      });

      if (title.length > 0) {
        tl.add(
          gsap.to(title, {
            xPercent: 100,
            stagger: 0.1,
            opacity: 1,
            duration: 0.8,
            onComplete: function () {
              // clear transform to maintain responsiveness of element
              this.targets().forEach((el) => {
                el.classList.remove("slide-in-left-title");
                el.style.removeProperty("transform");
              });
            },
          }),
          "<"
        );
      }

      if (circle.length > 0) {
        tl.add(
          gsap.to(circle, {
            xPercent: 100,
            opacity: 1,
            duration: 0.3,
            onComplete: function () {
              // clear transform to maintain responsiveness of element
              this.targets().forEach((el) => {
                el.classList.remove("slide-in-left-circle");
                el.style.removeProperty("transform");
              });
            },
          }),
          "<"
        );
      }
    });
  },
});
